import { render, staticRenderFns } from "./users-posts.vue?vue&type=template&id=28fa0058&"
import script from "./users-posts.vue?vue&type=script&lang=js&"
export * from "./users-posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports